const mEditionBillingMyPaymentsSubscribedPlan = {
  mEditionBillingMyPaymentsSubscribedPlan: {
    infoLeft: {
      product: {
        academy: 'Profesional Universidad',

        administrator: 'Administradores',

        affiliations: 'Afiliaciones',

        assets: 'Proyectos',

        commissions: {
          line1: 'Comisiones',
          line2: 'Sin Comisiones'
        },

        evaluations: 'Evaluaciones',

        instructor: 'Instructores',

        integrations: 'Integraciones',

        liveClasses: 'Clases en vivo por Zoom',

        mails: 'Listas de e-mail',

        maps: 'Mapas de Aprendizaje',

        name: 'PLAN',

        not: 'No',

        products: 'Productos',

        projects: 'Proyectos',

        salesData: 'Puntos de Venta',

        student: 'Alumnos',

        studentControl: 'Control de alumnos',

        studentImport: 'Importación de alumnos',

        teacher: 'Profesores',

        unlimited: 'Ilimitado'
      }
    },

    infoRigth: {
      changePlan: {
        paragraph: '¿Necesitas aumentar las características de tu plan?',
        btn: '¡ENTONCES ACTUALIZA TU PLAN!'
      },

      pendingChangePlan: {
        paragraph: '¡Hemos detectado una solicitud de cambio de Cambio de Plan!',
        btn: 'VER DETALLE'
      },

      pendingPaymentMethod: {
        paragraph: '¡Hemos detectado una solicitud de Cambio de Medio de Pago!',
        btn: 'VER DETALLE'
      },

      subscription: {
        cancelDate: 'Podrás acceder hasta el día',

        compensa: 'Compensación de',

        cupon: {
          line1: 'Se aplicó descuento',
          line2: 'del'
        },

        free: 'Gratis',

        idExtern: 'ID de suscripción en',

        montoParcial: 'Monto Parcial de',

        name: 'PLAN',

        payNext: 'El próximo pago será el',

        plan: {
          line1: 'A pagar en',
          line2: 'de'
        },

        payMethod: 'Medio de pago',

        payTrial: {
          line1: 'Pago por periodo de prueba de',
          line2: 'con'
        },

        state: {
          line1: 'Suscripción',
          line2: 'desde'
        },

        total: 'Monto total de',

        trial: 'Periodo de prueba de',

        title: 'SUSCRIPCIÓN ACTUAL'
      }
    }
  }
}

export default mEditionBillingMyPaymentsSubscribedPlan
